import { styled } from '@mui/material';
import React from 'react';

// Outer wrapper that provides the outside frame and positioning context
const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  borderRadius: '12px',
  padding: '1px',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '12px',
}));

// Visible outer border per Figma (#889eaa). Container for inner content
const OuterBorder = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  border: '1px solid #B9C6CD',
  borderRadius: '12px',
  boxSizing: 'border-box',
  display: 'flex',
}));

// Inner lighter border container; holds title badge and children
const InnerBorder = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  border: '1px solid white',
  borderRadius: '11px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
}));

const Content = styled('div')(({ cardInlinePadding }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  paddingInline: cardInlinePadding,
  paddingTop: '24px',
  paddingBottom: '12px',
  borderRadius: '10px',
  background: 'linear-gradient(90deg, #E3E7E8 0%, #E5E9EA 100%)',
}));

// Title badge that sits on the top border line

const TitleBadge = styled('div')(() => ({
  position: 'absolute',
  top: '-7px',
  left: '12px',
  backgroundColor: '#E9ECED',
  paddingLeft: '6px',
  paddingRight: '6px',
  height: '10px',
  display: 'flex',
  alignItems: 'center',
  zIndex: 10,
}));

const TitleText = styled('p')(() => ({
  margin: 0,
  fontWeight: 400,
  color: '#394B57',
  fontSize: '12px',
  lineHeight: '24px',
  whiteSpace: 'nowrap',
  userSelect: 'none',
}));

// Props mirror existing API and add a `title` prop for the label
const CardSection = ({ title = 'Experiment Setup', cardInlinePadding = '24px', ...props }) => {
  const { sx, ...rest } = props; // destructure sx and rest of props
  const defaultSx = { width: '100%', minWidth: '300px', height: '100%', borderRadius: '12px' };

  return (
    <Root sx={[defaultSx, sx]} {...rest}>
      <OuterBorder>
        <InnerBorder>
          <TitleBadge>
            <TitleText>{title}</TitleText>
          </TitleBadge>
          <Content cardInlinePadding={cardInlinePadding}>{props.children}</Content>
        </InnerBorder>
      </OuterBorder>
    </Root>
  );
};

export default CardSection;
